import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Message } from '@app/ngrx-message/models/client/message';
import { MessageStoreService } from '@app/ngrx-message/services/message/message-store.service';
import {
  ANALYTICS_ACTIONS,
  baseInventoryAnalyticsTransform,
  FOOD_COST_ACTIONS,
  InventoryAnalyticsConstants,
} from '@usf/ngrx-inventory';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { map, tap } from 'rxjs';
import { MessageTypeEnum } from '../../ngrx-message/constants/messageTypeEnum';
import { DatePipe } from '@angular/common';
import { FoodCostCalculatorService } from '@inventory/pages/food-cost-calculator/services/food-cost-calculator.service';
@Injectable({
  providedIn: 'root',
})
export class FoodCostEffects {
  createFoodCostReportSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FOOD_COST_ACTIONS.createSuccess),
      map(action => {
        this.displayToastMessage(
          MessageTypeEnum.success,
          this.translateService.instant(
            'i18n.inventory.foodCost.createReportSuccess',
          ),
        );
        return ANALYTICS_ACTIONS.trackCreateNewFoodCostReport({
          tracking: {
            analytics: {
              data: {
                capability: InventoryAnalyticsConstants.listCapability,
                event: InventoryAnalyticsConstants.createNewFoodCostReportEvent,
              },
              transformFunc: baseInventoryAnalyticsTransform,
            },
          },
        });
      }),
    ),
  );

  createFoodCostReportFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FOOD_COST_ACTIONS.createFail),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              'i18n.inventory.foodCost.createReportFail',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  deleteFoodCostReportSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FOOD_COST_ACTIONS.deleteSuccess),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.success,
            this.translateService.instant(
              'i18n.inventory.foodCost.deleteReportSuccessMessage',
              {
                startPeriod: this.datePipe.transform(
                  action.startPeriod,
                  'M/d/yyyy',
                ),
                endPeriod: this.datePipe.transform(
                  action.endPeriod,
                  'M/d/yyyy',
                ),
              },
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  deleteFoodCostReportFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FOOD_COST_ACTIONS.deleteFail),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              'i18n.inventory.foodCost.deleteReportFailMessage',
              {
                startPeriod: this.datePipe.transform(
                  action.startPeriod,
                  'M/d/yyyy',
                ),
                endPeriod: this.datePipe.transform(
                  action.endPeriod,
                  'M/d/yyyy',
                ),
              },
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  purchaseTotalSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FOOD_COST_ACTIONS.purchaseTotalSuccess),
        tap(action => {
          this.foodCostService.recieveFoodPurchaseData(action.usfPurchaseTotal);
        }),
      ),
    { dispatch: false },
  );

  purchaseTotalFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FOOD_COST_ACTIONS.purchaseTotalFail),
        tap(action => {
          this.foodCostService.recieveFoodPurchaseData(action.error);
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              'i18n.inventory.foodCost.foodPurchaseTotalFailMessage',
            ),
            false,
          );
        }),
      ),
    { dispatch: false },
  );

  displayToastMessage(
    type: MessageTypeEnum,
    message: string,
    sticky = false,
  ): void {
    this.messageStoreService.upsertMessage({
      type,
      display: message,
      toast: true,
      sticky,
    } as Message);
  }

  constructor(
    private actions$: Actions,
    private datePipe: DatePipe,
    private translateService: TranslateService,
    private messageStoreService: MessageStoreService,
    private foodCostService: FoodCostCalculatorService,
    public store: Store,
  ) {}
}
